<template>
	<div>
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" size="small" placeholder="" prefix-icon="el-icon-search"
					class="search-input" @keypress.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>

			</div>
			<el-button type="primary" icon="el-icon-plus" size="small" @click.stop="openAddCreditRulesMapDialog()">
				新增规则映射
			</el-button>
		</div>
		<!-- 内容 -->
		<el-table border v-loading="loading" :data="creditRulesMapList" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px;table-layout:fixed">
			<el-table-column prop="creditRuleMapID" label="规则映射编号" align="center" />
			<el-table-column prop="creditRuleID" label="规则ID" align="center" />

			<el-table-column prop="creditRuleName" label="规则名" align="center">
			</el-table-column>

			<el-table-column label="操作" align="center" width="250">
				<template slot-scope="scope">
					<el-button size="small" type="primary" @click.stop="openEditCreditRulesMapDialog(scope.row)">
						编辑
					</el-button>
					<el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
						@click.stop="deleteCreditRuleMapOrBack(scope.row)">
						{{ scope.row.isDeleted ? "恢复" : "删除" }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- showEditCreditRulesDlg -->
		<el-dialog :title="editCreditRulesMapType === 'create' ? '新增积分映射规则' : '修改积分映射规则'"
			:visible.sync="showEditCreditRulesMapDlg" width="40%">
			<el-form ref="editCreditRulesMapFormRef" :model="editCreditRulesMapForm" status-icon>
				<el-form-item label="映射编码(不能重复)">
					<el-input-number v-model="editCreditRulesMapForm.creditRuleMapID"></el-input-number>
				</el-form-item>
				<el-form-item label="选择规则">
					<el-select v-model="editCreditRulesMapForm.creditRuleID">
						<el-option v-for="item in creditRulesList" :key="item.creditRuleID" :value="item.creditRuleID"
							:label="item.creditRuleContent">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="规则名">
					<el-input v-model="editCreditRulesMapForm.creditRuleName"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="showEditCreditRulesMapDlg = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="handleCreateOrEditCreditRulesMap()">
					确 定
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		deepClone
	} from "@/utils/index"
	import {
		addCreditRuleMap,
		deleteCreditRuleMap,
		getCreditRuleMapList,
		getCreditRuleList,
		updateCreditRuleMap,
		
	} from "@/api/CreditRule/CreditRule"
	export default {
		data() {
			return {
				loading: false,
				pageSize: 10,
				currentPage: 1,
				totalCount: 0,
				creditRulesMapList: [],
				searchValue: "",
				showEditCreditRulesMapDlg: false,
				editCreditRulesMapForm: {},
				editCreditRulesMapType: "",
				creditRulesList: [],

			}
		},
		created() {
			this.getCreditRulesMapList()
			this.getAllCreditRulesList()
		},
		methods: {
			search() {
				this.currentPage = 1
				this.getCreditRulesMapList()
			},
			currentChange(page) {
				this.currentPage = page
				this.getCreditRulesMapList()
			},
			getAllCreditRulesList() {
				getCreditRuleList().then(res => {
					return res.data.total
				}).then(total => {
					return getCreditRuleList({
						pageSize: total
					})
				}).then(res => {
					this.creditRulesList = res.data.rows
				}).catch(e => {
					this.$message.warning("获取积分规则失败")
				})
			},
			getCreditRulesMapList() {
				getCreditRuleMapList({
					pageSize: this.pageSize,
					pageNumber: this.currentPage,
					keyWord: this.searchValue
				}).then((res) => {
					if (res.code === 200) {
						this.totalCount = res.data.total
						this.creditRulesMapList = res.data.rows
					} else {
						this.$message.warning(res.message)
					}
				})
			},
			openAddCreditRulesMapDialog() {
				this.editCreditRulesMapForm = {}
				this.editCreditRulesMapType = 'create'
				this.showEditCreditRulesMapDlg = true
			},
			openEditCreditRulesMapDialog(entity) {
				this.editCreditRulesMapForm = deepClone(entity)
				this.editCreditRulesMapType = 'edit'
				this.showEditCreditRulesMapDlg = true
			},
			handleCreateOrEditCreditRulesMap() {
				if (this.editCreditRulesMapType === 'create') {
					addCreditRuleMap(this.editCreditRulesMapForm).then(res => {
						if (res.code === 200) {
							this.$message.success("添加成功")
							this.showEditCreditRulesMapDlg = false
							this.search()
						} else {
							this.$message.warning(res.message)
						}
					})
				}else if(this.editCreditRulesMapType === 'edit'){
					updateCreditRuleMap(this.editCreditRulesMapForm).then(res => {
						if (res.code === 200) {
							this.$message.success("修改成功")
							this.showEditCreditRulesMapDlg = false
							this.getCreditRulesMapList()
						} else {
							this.$message.warning(res.message)
						}
					})
				}

			},
			deleteCreditRuleMapOrBack(entity) {
				this.$confirm("是否删除该积分规则映射", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					deleteCreditRuleMap({
						creditRuleMapId: entity.creditRuleMapID
					}).then(res => {
						if (res.code === 200) {
							this.$message.success("删除成功")
							this.getCreditRulesMapList()
						} else {
							this.$message.warning(res.message)
						}

					})
				})

			}
		},
	}
</script>

<style>
</style>
